import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-756664bc"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["src"];
import videojs from "video.js";
import video_zhCN from "video.js/dist/lang/zh-CN.json";
import "video.js/dist/video-js.css";
export default {
  props: {
    videoUrl: String,
    coverUrl: String,
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    isAutoPlay: {
      type: Boolean,
      default: false
    }
  },

  setup(__props) {
    const props = __props;
    videojs.addLanguage("zh-CN", video_zhCN); // 播放器实例

    let player = ref(null); // vidoe dom

    let videoPlayer = ref(null); // 播放器参数配置

    const options = {
      controls: true,
      //是否显示播放器控件
      autoplay: props.isAutoPlay,
      //是否自动播放
      poster: props.coverUrl,
      preload: "auto",
      aspectRatio: '16:9',
      fluid: false,
      // 自适应宽高
      controlBar: {
        children: [{
          name: "playToggle"
        }, {
          name: "currentTimeDisplay"
        }, {
          name: "progressControl"
        }, {
          name: "durationDisplay"
        }, {
          name: "volumePanel",
          inline: false
        }, {
          name: "FullscreenToggle"
        }]
      }
    }; // 初始化视频播放器

    const initVideoPlayer = url => {
      player.value = videojs(unref(videoPlayer), options, onPlayerReady);

      function onPlayerReady() {
        console.log("onPlayerReady", this);
        this.src(url); // 监听视频播放

        this.on('play', function () {
          console.log('play');
        }); // 监听视频暂停

        this.on('pause', function () {
          console.log('pause');
        });
      }
    };

    onMounted(() => {
      props.videoUrl && initVideoPlayer(props.videoUrl);
    });
    onUnmounted(() => {
      player.value.dispose();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "video-box",
        style: _normalizeStyle({
          width: __props.width,
          height: __props.height
        })
      }, [__props.videoUrl ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        class: "video-js vjs-big-play-centered",
        ref_key: "videoPlayer",
        ref: videoPlayer
      }, null, 512)) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: __props.coverUrl,
        class: "video-cover",
        alt: ""
      }, null, 8, _hoisted_1))], 4);
    };
  }

};